export default "__VITE_ASSET__BTYH7Obf__"